var sectionsContent = []
var subSectionEvents = []
var _URL = window.URL || window.webkitURL;
$(document).ready(function () {

  if ($(document).width() < 767) {
    $('#customize_button').remove()
  }

  for (let i = 0; i < 20; i++) {
    if (document.getElementById('sectionsMaindd-' + i)) {
      showSectionsMenu(i)
    }
    else {
      break;
    }
  }


  const select1 = document.getElementById("font-selector")
  const select2 = document.getElementById("font-selector-2")

  fetch("https://www.googleapis.com/webfonts/v1/webfonts?key=AIzaSyBk5d60ANsCB9T8zbtsZqghVStGielL5JI").then(
    (response) => response.json()
  ).then(
    (data) => {
      data.items.map((item) => {
        const option = document.createElement("option")
        option.value = item.family
        option.innerHTML = item.family
        const option2 = document.createElement("option")
        option2.value = item.family
        option2.innerHTML = item.family
        if (select1) {
          select1.appendChild(option)
        }
        if (select2) {
          select2.appendChild(option2)
        }
      })
    }
  )


  if (select1) {
    select1.addEventListener("change", () => {
      let apiUrl = [];
      apiUrl.push('https://fonts.googleapis.com/css?family=')
      apiUrl.push(select1.value.replace(/ /g, '+'))
      let url = apiUrl.join('')
      let fontStyle = `h1, h2, h3, h4, h5, h6 {font-family: '${select1.value}', sans-serif !important;}`
      if (!document.getElementById("googleFont")) {
        let headLink = document.createElement('link')
        headLink.rel = "stylesheet"
        headLink.href = url
        headLink.id = "googleFont"
        document.body.appendChild(headLink)
      } else {
        let currentHeadLink = document.getElementById("googleFont")
        currentHeadLink.href = url
      }
      if (!document.getElementById("customStyle")) {

        let headStyle = document.createElement("style")
        headStyle.innerText = fontStyle
        headStyle.id = "customStyle"
        document.body.appendChild(headStyle)
      } else {
        let customStyle = document.getElementById("customStyle")
        console.log(customStyle)
        customStyle.innerHTML = fontStyle
      }
    })
  }

  if (select2) {
    select2.addEventListener("change", () => {
      let apiUrl = [];
      apiUrl.push('https://fonts.googleapis.com/css?family=')
      apiUrl.push(select2.value.replace(/ /g, '+'))
      let url = apiUrl.join('')
      let fontStyle = `div, a {font-family: '${select2.value}', sans-serif !important;}`
      if (!document.getElementById("googleFont2")) {
        let headLink = document.createElement('link')
        headLink.rel = "stylesheet"
        headLink.href = url
        headLink.id = "googleFont2"
        document.body.appendChild(headLink)
      } else {
        let currentHeadLink = document.getElementById("googleFont2")
        currentHeadLink.href = url
      }
      if (!document.getElementById("customStyle2")) {

        let headStyle = document.createElement("style")
        headStyle.innerText = fontStyle
        headStyle.id = "customStyle2"
        document.body.appendChild(headStyle)
      } else {
        let customStyle = document.getElementById("customStyle2")
        console.log(customStyle)
        customStyle.innerHTML = fontStyle
      }
    })
  }


  document.getElementById('color-primario')?.addEventListener('change', (e) => {
    $('#customize').append(`<style>
    .pc-text{
      color:${e.target.value}!important;
    }
    .pc-border{
      border-color:${e.target.value}!important;
    }
    .pc-btn{
      background-color:${e.target.value}!important;
      border-color:${e.target.value}!important;
    }
    .pc-btn:hover{
      color:${e.target.value}!important;
    }
    .pc-border-hover:hover{
      border-color:${e.target.value}!important;
    }
    .pc-input{
      border-color:${e.target.value}!important;
    }
    .pc-bg{
      background-color:${e.target.value}!important;
    }
    .sc-btn{
      color:${e.target.value}!important;
    }
    .sc-btn:hover{
      background-color:${e.target.value}!important;
    }
    .tc-btn{
      color:${e.target.value}!important;
    }
    .pc-underline-btn{
      border-bottom-color: ${e.target.value}!important;
      color: ${e.target.value}!important;
    }
    .pc-underline-btn:hover{
      border-bottom-color: ${e.target.value}99!important;
      color: ${e.target.value}99!important;
    }
    .sc-underline-btn:hover{
      border-bottom-color: ${e.target.value}!important;
      color: ${e.target.value}!important;
    }
    </style`)
  })
  document.getElementById('color-secundario')?.addEventListener('change', (e) => {
    $('#customize').append(`<style>
    .sc-text{
      color:${e.target.value}!important;
    }
    .sc-btn{
      background-color:${e.target.value}!important;
      border-color:${e.target.value}!important;
    }
    .sc-btn:hover{
      border-color:${e.target.value}!important;
      color:${e.target.value}!important;
    }
    .sc-bg{
      background-color:${e.target.value}!important;
    }
    .pc-btn{
      color:${e.target.value}!important;
    }
    .sc-underline-btn{
      border-bottom-color: ${e.target.value}!important;
      color: ${e.target.value}!important;
    }
    </style`)
  })
  document.getElementById('color-terciario')?.addEventListener('change', (e) => {
    $('#customize').append(`<style>
    .pc-btn:hover{
      background-color:${e.target.value}!important;
      border-color:${e.target.value}!important;
    }
    .pc-input:focus{
      border-color:${e.target.value}!important;
    }
    .tc-text{
      color:${e.target.value}!important;
    }
    .tc-btn{
      background-color:${e.target.value}!important;
      border-color:${e.target.value}!important;
    }
    .tc-btn:hover{
      background-color:transparent!important;
      border-color:${e.target.value}!important;
      color:${e.target.value}!important;
    }
    .tc-bg{
      background-color:${e.target.value}!important;
    }
    .tc-underline-btn{
      border-bottom-color: ${e.target.value}!important;
      color: ${e.target.value}!important;
    }
    .tc-underline-btn:hover{
      border-bottom-color: ${e.target.value}99!important;
      color: ${e.target.value}99!important;
    }
    </style`)
  })

  $('#sectionsMenu-0').slideUp()


})

function showSectionsMenu(index) {
  if ($('#sectionsMenu-' + index).is(":visible")) {
    $('#sectionsMenu-' + index).slideUp()
  }
  else {
    $('#sectionsMenu-' + index).slideDown()
  }
}

function showCustomizeMenu(val) {
  if (val == 0) {
    $('#customize_button').animate({
      left: '-30%'
    });
    $('#customize_menu').animate({
      width: '34vw'
    });
  }
  else {
    $('#customize_button').animate({
      left: '12%'
    });
    $('#customize_menu').animate({
      width: '0%'
    });
  }
}

function showSectionFields(nmb) {
  console.log('entra')
  if ($('#section_' + nmb).is(":visible")) {
    $('#section_' + nmb).slideUp()
  }
  else {
    $('#section_' + nmb).slideDown()
  }
}

function deleteDD(nmb, index) {
  $('#section_' + nmb).slideUp()
  $('#section-' + nmb).remove()
  if ($('#dd-container_' + nmb).attr('parent') >= 0) {
    for (let i = 0; i < sectionsContent[index].length; i++) {
      if (sectionsContent[index][i].id == $('#dd-container_' + nmb).attr('parent')) {
        if (sectionsContent[index][i].images) {
          for (let j = 0; j < sectionsContent[index][i].images.length; j++) {
            if (sectionsContent[index][i].images[j].id == nmb) {
              sectionsContent[index][i].images.splice(sectionsContent[index][i].images.indexOf(sectionsContent[index][i].images[j]), 1)
              break
            }
          }
        }
        else {
          for (let j = 0; j < sectionsContent[index][i].ubications.length; j++) {
            if (sectionsContent[index][i].ubications[j].id == nmb) {
              sectionsContent[index][i].ubications.splice(sectionsContent[index][i].ubications.indexOf(sectionsContent[index][i].ubications[j]), 1)
              break
            }
          }
        }
      }
    }
  }
  else {
    for (let i = 0; i < sectionsContent[index].length; i++) {
      if (sectionsContent[index][i].id == nmb) {
        sectionsContent[index].splice(sectionsContent[index].indexOf(sectionsContent[index][i]), 1)
        break
      }
    }
  }
  setTimeout(() => {
    $('#dd-container_' + nmb).remove()
  }, 500);
  var existEvents = false
  for (let i = 0; i < sectionsContent.length; i++) {
    for (let j = 0; j < sectionsContent[i].length; j++) {
      if (sectionsContent[i][j].type == "wedsite_secciones_eventos") {
        existEvents = true
      }
    }
  }
  if (existEvents) {
    for (let i = 0; i < sectionsContent.length; i++) {
      console.log('Entra a reasignar eventos ' + i)
      $('.mainEventsDD' + i).attr('onclick', '')
      $('.mainEventsDD' + i).css('background-color', '#c0c0c0')
      $('.mainEventsDD' + i).css('cursor', 'default')
    }
  }
  else {
    for (let i = 0; i < sectionsContent.length; i++) {
      $('.mainEventsDD' + i).attr('onclick', "addSection('Eventos'," + i + ",true)")
      $('.mainEventsDD' + i).css('background-color', 'transparent')
      $('.mainEventsDD' + i).css('cursor', 'pointer')
    }
  }
}
var sectionCount = 0
function addMapBlock(element) {
  var index = element.getAttribute('index')
  var nmb = element.getAttribute('nmb')
  var sectionName = element.getAttribute('name')
  $('#block_container_' + nmb).append(`<div id="dd-container_${sectionCount}" parent="${nmb}" data-delay="0" data-hover="false" class="cust-dd w-dropdown">
                    <div onclick="showSectionFields('${sectionCount}')" class="cust-dd-tog sub-dd w-dropdown-toggle">
                      <div>Ubicación</div>
                      <div class="dd-icon w-icon-dropdown-toggle"></div>
                    </div>
                    <nav id="section_${sectionCount}" class="cust-dd-drawer w-dropdown-list">
                    <div class="flex ver gap">
                      <div class="cust-field-wrap">
                        <label for="field" class="field-label">Nombre de Ubicación</label
                        ><input
                          type="text"
                          class="cust-input w-input"
                          maxlength="256"
                          name="title"
                          data-name="Field"
                          placeholder="Título"
                          id="title-input-${sectionCount}"
                          required=""
                        >
                      </div>
                      <div class="cust-field-wrap">
                        <label class="field-label">Dirección</label><textarea
                          id="description-input-${sectionCount}"
                          name="field-3"
                          maxlength="5000"
                          data-name="Field 3"
                          placeholder="Descripción"
                          class="cust-input textarea w-input"
                        ></textarea>
                      </div>
                      <div class="cust-field-wrap">
                        <label for="field" class="field-label">Imagen de ubicación (Comprueba que la imagen no supere los 20MP ni los 20 MB, de lo contrario no se guardará)</label
                        ><input
                          type="file"
                          accept="image/png, image/jpeg"
                          maxlength="256"
                          name="title"
                          data-name="Field"
                          placeholder="Imagen"
                          id="image-input-${sectionCount}"
                          required=""
                        >
                      </div>
                      <div class="cust-field-wrap">
                        <label for="field" class="field-label">Link de Google Maps (obligatorio)</label
                        ><input
                          type="text"
                          class="cust-input w-input"
                          maxlength="256"
                          name="title"
                          data-name="Field"
                          placeholder="Link de botón"
                          id="link-input-${sectionCount}"
                          required=""
                        >
                        <div id="cfw-${sectionCount}"></div>
                        <a href="#" onclick="deleteDD(${sectionCount},${index})" class="cust-del w-inline-block"
                          ><img loading="lazy" src="//cdn.shopify.com/s/files/1/0665/4636/8751/t/3/assets/trash-01.svg?v=79518031219586732181678131632" alt="" class="icon">
                          <div style="color:#e73535">Eliminar Bloque</div>
                        </a>
                      </div>
                      </div>
                    </nav>
                  </div>`)
  var item
  item = createUbicationItem(sectionCount)
  for (let i = 0; i < sectionsContent[index].length; i++) {
    if (sectionsContent[index][i].id == nmb) {
      console.log(sectionsContent[index][i])
      console.log(sectionsContent[index][i].ubications)
      sectionsContent[index][i].ubications.push({ "id": sectionCount, "type": "bloques_ubicaciones", "fields": [{ "key": "nombre_de_ubicacion", "value": "" }, { "key": "direccion", "value": "" }, { "key": "imagen", "value": "" }, { "key": "link_a_google_maps", "value": "" }] })
    }
  }
  $('#ubication-element-container-' + nmb).append(item)
  reciveMapData(sectionCount, nmb, index)
  sectionCount++
}


async function reciveMapData(nmb, oldnmb, index) {
  if ($('#title-input-' + nmb).length) {
    document.getElementById('title-input-' + nmb).addEventListener('input', (e) => {
      $('#title-' + nmb).text(e.target.value)
      for (let i = 0; i < sectionsContent[index].length; i++) {
        if (sectionsContent[index][i].id == oldnmb) {
          for (let j = 0; j < sectionsContent[index][i].ubications.length; j++) {
            if (sectionsContent[index][i].ubications[j].id == nmb) {
              for (let k = 0; k < sectionsContent[index][i].ubications[j].fields.length; k++) {
                if (sectionsContent[index][i].ubications[j].fields[k].key == "nombre_de_ubicacion") {
                  sectionsContent[index][i].ubications[j].fields[k].value = e.target.value
                  break
                }
              }
            }
          }
        }
      }
    })
  }
  if ($('#description-input-' + nmb).length) {
    document.getElementById('description-input-' + nmb).addEventListener('input', (e) => {
      $('#content-' + nmb).text(e.target.value)
      for (let i = 0; i < sectionsContent[index].length; i++) {
        if (sectionsContent[index][i].id == oldnmb) {
          for (let j = 0; j < sectionsContent[index][i].ubications.length; j++) {
            if (sectionsContent[index][i].ubications[j].id == nmb) {
              for (let k = 0; k < sectionsContent[index][i].ubications[j].fields.length; k++) {
                if (sectionsContent[index][i].ubications[j].fields[k].key == "direccion") {
                  sectionsContent[index][i].ubications[j].fields[k].value = e.target.value
                  break
                }
              }
            }
          }
        }
      }
    })
  }
  if ($('#link-input-' + nmb).length) {
    document.getElementById('link-input-' + nmb).addEventListener('input', (e) => {
      console.log(e.target.value)
      if (!e.target.value.includes('https://www.google.com/maps/place/')) {
        if ($('#cfw-error-' + nmb).length == 0) {
          $('#cfw-' + nmb).prepend('<div id="cfw-error-' + nmb + '" class="error-msg">La url debe comenzar con "https://www.google.com/maps/place/"</div>')
        }
      }
      else {
        if ($('#cfw-error-' + nmb).length > 0) {
          $('#cfw-error-' + nmb).remove()
        }
      }
      $('#link-' + nmb).attr("href", e.target.value)
      for (let i = 0; i < sectionsContent[index].length; i++) {
        if (sectionsContent[index][i].id == oldnmb) {
          for (let j = 0; j < sectionsContent[index][i].ubications.length; j++) {
            if (sectionsContent[index][i].ubications[j].id == nmb) {
              for (let k = 0; k < sectionsContent[index][i].ubications[j].fields.length; k++) {
                if (sectionsContent[index][i].ubications[j].fields[k].key == "link_a_google_maps") {
                  sectionsContent[index][i].ubications[j].fields[k].value = e.target.value.replaceAll(' ', '')
                  break
                }
              }
            }
          }
        }
      }
    })
  }
  if ($('#image-input-' + nmb).length) {
    document.getElementById('image-input-' + nmb).addEventListener('change', async (event) => {
      var resolution
      var file, img;
      if ((file = event.target.files[0])) {
        img = new Image();
        var objectUrl = _URL.createObjectURL(file);
        console.log(file)
        console.log(objectUrl)
        img.onload = async function () {
          _URL.revokeObjectURL(objectUrl);
          resolution = (this.width * this.height) / 1000000
          console.log(resolution)

          if (resolution < 20) {
            if ($('#image-warning-' + nmb).length > 0) {
              $('#image-warning-' + nmb).remove()
            }
            var previewImage = document.getElementById('image-' + nmb)
            var file = event.target.files[0];
            var fileId = await getFileId(file)
            for (let i = 0; i < sectionsContent[index].length; i++) {
              if (sectionsContent[index][i].id == oldnmb) {
                for (let j = 0; j < sectionsContent[index][i].ubications.length; j++) {
                  if (sectionsContent[index][i].ubications[j].id == nmb) {
                    for (let k = 0; k < sectionsContent[index][i].ubications[j].fields.length; k++) {
                      if (sectionsContent[index][i].ubications[j].fields[k].key == "imagen") {
                        sectionsContent[index][i].ubications[j].fields[k].value = fileId
                        break
                      }
                    }
                  }
                }
              }
            }
            var reader = new FileReader();

            reader.onload = (readerEvent) => {
              var image = new Image();
              image.src = readerEvent.target.result;
              previewImage.src = image.src;
            };

            reader.readAsDataURL(file);
          }
          else {
            if ($('#image-warning-' + nmb).length > 0) {
              $('#image-warning-' + nmb).remove()
            }
            console.log(resolution)
            $('#image-input-' + nmb).val('')
            $('#image-input-' + nmb).parent().append('<div id="image-warning-' + nmb + '" style="margin-top:5px;background-color:#fae3d7">La imagen seleccionada debe tener menos de 20MP</div>')
          }
        };
        img.src = objectUrl;
      }
    });
  }
}


function addBlock(element) {
  var index = element.getAttribute('index')
  var nmb = element.getAttribute('nmb')
  var sectionName = element.getAttribute('name')
  $('#block_container_' + nmb).append(`<div id="dd-container_${sectionCount}" parent="${nmb}" data-delay="0" data-hover="false" class="cust-dd w-dropdown">
                    <div onclick="showSectionFields('${sectionCount}')" class="cust-dd-tog sub-dd w-dropdown-toggle">
                      <div>Imagen de Galeria</div>
                      <div class="dd-icon w-icon-dropdown-toggle"></div>
                    </div>
                    <nav id="section_${sectionCount}" class="cust-dd-drawer w-dropdown-list">
                    <div class="flex ver gap">
                      <div class="cust-field-wrap">
                        <label for="field" class="field-label">Título</label
                        ><input
                          type="text"
                          class="cust-input w-input"
                          maxlength="256"
                          name="title"
                          data-name="Field"
                          placeholder="Título"
                          id="title-input-${sectionCount}"
                          required=""
                        >
                      </div>
                      <div class="cust-field-wrap">
                        <label class="field-label">Descripción</label><textarea
                          id="description-input-${sectionCount}"
                          name="field-3"
                          maxlength="5000"
                          data-name="Field 3"
                          placeholder="Descripción"
                          class="cust-input textarea w-input"
                        ></textarea>
                      </div>
                      <div class="cust-field-wrap">
                        <label for="field" class="field-label">Imagen (Comprueba que la imagen no supere los 20MP ni los 20 MB, de lo contrario no se guardará)</label
                        ><input
                          type="file"
                          accept="image/png, image/jpeg"
                          maxlength="256"
                          name="title"
                          data-name="Field"
                          placeholder="Imagen"
                          id="image-input-${sectionCount}"
                          required=""
                        >
                      </div>
                      <div class="cust-field-wrap">
                        <label for="field" class="field-label">Link de botón</label
                        ><input
                          type="text"
                          class="cust-input w-input"
                          maxlength="256"
                          name="title"
                          data-name="Field"
                          placeholder="Link de botón"
                          id="link-input-${sectionCount}"
                          required=""
                        >
                      </div>
                      <div class="cust-field-wrap">
                        <label for="field" class="field-label">Texto de botón</label
                        ><input
                          type="text"
                          class="cust-input w-input"
                          maxlength="256"
                          name="title"
                          data-name="Field"
                          placeholder="Texto de botón"
                          id="linkText-input-${sectionCount}"
                          required=""
                        >
                      </div>
                      <a href="#" onclick="deleteDD(${sectionCount},${index})" class="cust-del w-inline-block"
                        ><img loading="lazy" src="//cdn.shopify.com/s/files/1/0665/4636/8751/t/3/assets/trash-01.svg?v=79518031219586732181678131632" alt="" class="icon">
                        <div style="color:#e73535">Eliminar Bloque</div>
                      </a>
                      </div>
                    </nav>
                  </div>`)
  var item
  if (sectionName == 'Galería en cuadrícula') {
    item = createGridItem(sectionCount)
  }
  if (sectionName == 'Galería en carrusel') {
    item = createSliderItem(sectionCount)
  }
  if (sectionName == 'Galería en lista') {
    item = createListItem(sectionCount)
  }
  for (let i = 0; i < sectionsContent[index].length; i++) {
    if (sectionsContent[index][i].id == nmb) {
      console.log(sectionsContent[index][i])
      console.log(sectionsContent[index][i].images)
      sectionsContent[index][i].images.push({ "id": sectionCount, "type": "bloques_general", "fields": [{ "key": "titulo_de_bloque", "value": "" }, { "key": "descripcion_de_bloque", "value": "" }, { "key": "imagen_de_bloque", "value": "" }, { "key": "link_de_bloque", "value": "" }, { "key": "texto_del_link", "value": "" }] })
    }
  }
  $('#img-container-' + nmb).append(item)
  reciveBlockData(sectionCount, nmb, index)
  sectionCount++
}

async function reciveBlockData(nmb, oldnmb, index) {
  if ($('#title-input-' + nmb).length) {
    document.getElementById('title-input-' + nmb).addEventListener('input', (e) => {
      $('#title-' + nmb).text(e.target.value)
      for (let i = 0; i < sectionsContent[index].length; i++) {
        if (sectionsContent[index][i].id == oldnmb) {
          for (let j = 0; j < sectionsContent[index][i].images.length; j++) {
            if (sectionsContent[index][i].images[j].id == nmb) {
              for (let k = 0; k < sectionsContent[index][i].images[j].fields.length; k++) {
                if (sectionsContent[index][i].images[j].fields[k].key == "titulo_de_bloque") {
                  sectionsContent[index][i].images[j].fields[k].value = e.target.value
                  break
                }
              }
            }
          }
        }
      }
    })
  }
  if ($('#description-input-' + nmb).length) {
    document.getElementById('description-input-' + nmb).addEventListener('input', (e) => {
      $('#content-' + nmb).text(e.target.value)
      for (let i = 0; i < sectionsContent[index].length; i++) {
        if (sectionsContent[index][i].id == oldnmb) {
          for (let j = 0; j < sectionsContent[index][i].images.length; j++) {
            if (sectionsContent[index][i].images[j].id == nmb) {
              for (let k = 0; k < sectionsContent[index][i].images[j].fields.length; k++) {
                if (sectionsContent[index][i].images[j].fields[k].key == "descripcion_de_bloque") {
                  sectionsContent[index][i].images[j].fields[k].value = e.target.value
                  break
                }
              }
            }
          }
        }
      }
    })
  }
  if ($('#linkText-input-' + nmb).length) {
    document.getElementById('linkText-input-' + nmb).addEventListener('input', (e) => {
      $('#link-' + nmb).removeClass('d-none')
      $('#link-' + nmb).text(e.target.value)
      for (let i = 0; i < sectionsContent[index].length; i++) {
        if (sectionsContent[index][i].id == oldnmb) {
          for (let j = 0; j < sectionsContent[index][i].images.length; j++) {
            if (sectionsContent[index][i].images[j].id == nmb) {
              for (let k = 0; k < sectionsContent[index][i].images[j].fields.length; k++) {
                if (sectionsContent[index][i].images[j].fields[k].key == "texto_del_link") {
                  sectionsContent[index][i].images[j].fields[k].value = e.target.value
                  break
                }
              }
            }
          }
        }
      }
    })
  }
  if ($('#link-input-' + nmb).length) {
    document.getElementById('link-input-' + nmb).addEventListener('input', (e) => {
      var val = e.target.value
      if (!e.target.value.includes('http')) {
        val = 'https://' + e.target.value
      }
      val = val.replaceAll(' ', '')
      if (val == 'https://') {
        val = ''
      }
      $('#link-' + nmb).attr("href", val)
      for (let i = 0; i < sectionsContent[index].length; i++) {
        if (sectionsContent[index][i].id == oldnmb) {
          for (let j = 0; j < sectionsContent[index][i].images.length; j++) {
            if (sectionsContent[index][i].images[j].id == nmb) {
              for (let k = 0; k < sectionsContent[index][i].images[j].fields.length; k++) {
                if (sectionsContent[index][i].images[j].fields[k].key == "link_de_bloque") {
                  sectionsContent[index][i].images[j].fields[k].value = val
                  break
                }
              }
            }
          }
        }
      }
    })
  }
  if ($('#image-input-' + nmb).length) {
    document.getElementById('image-input-' + nmb).addEventListener('change', async (event) => {
      var file = document.getElementById('image-input-' + nmb);
      var resolution
      var file, img;
      if ((file = event.target.files[0])) {
        img = new Image();
        var objectUrl = _URL.createObjectURL(file);
        console.log(file)
        console.log(objectUrl)
        img.onload = async function () {
          _URL.revokeObjectURL(objectUrl);
          resolution = (this.width * this.height) / 1000000
          console.log(resolution)

          if (resolution < 20) {
            if ($('#image-warning-' + nmb).length > 0) {
              $('#image-warning-' + nmb).remove()
            }
            var previewImage = document.getElementById('image-' + nmb)
            var file = event.target.files[0];
            var fileId = await getFileId(file)
            for (let i = 0; i < sectionsContent[index].length; i++) {
              if (sectionsContent[index][i].id == oldnmb) {
                for (let j = 0; j < sectionsContent[index][i].images.length; j++) {
                  if (sectionsContent[index][i].images[j].id == nmb) {
                    for (let k = 0; k < sectionsContent[index][i].images[j].fields.length; k++) {
                      if (sectionsContent[index][i].images[j].fields[k].key == "imagen_de_bloque") {
                        sectionsContent[index][i].images[j].fields[k].value = fileId
                        break
                      }
                    }
                  }
                }
              }
            }
            var reader = new FileReader();

            reader.onload = (readerEvent) => {
              var image = new Image();
              image.src = readerEvent.target.result;
              previewImage.src = image.src;
            };

            reader.readAsDataURL(file);
          }
          else {
            if ($('#image-warning-' + nmb).length > 0) {
              $('#image-warning-' + nmb).remove()
            }
            console.log(resolution)
            $('#image-input-' + nmb).val('')
            $('#image-input-' + nmb).parent().append('<div id="image-warning-' + nmb + '" style="margin-top:5px;background-color:#fae3d7">La imagen seleccionada debe tener menos de 20MP</div>')
          }
        };
        img.src = objectUrl;
      }
    });
  }
}

async function addSection(sectionName, index, show) {
  $('#no-content' + index).slideUp()
  var fields = []
  var clase = ""
  if (sectionName != 'Eventos') {
    fields.push(`<div class="cust-field-wrap">
                <label for="field" class="field-label">Título</label
                ><input
                  type="text"
                  class="cust-input w-input"
                  maxlength="256"
                  name="title"
                  data-name="Field"
                  placeholder="Título"
                  id="title-input-${sectionCount}"
                  required=""
                >
              </div>`)
  }
  else {
    // fields.push(`<div id="wsEventsSection" class="flex ver mini-gap"></div>
    // <a href="#" onclick="wsaddEventoBlock(${sectionCount})" class="cust-del w-inline-block" style="font-family: Inconsolata, monospace!important">
    //   <img loading="lazy" src="//cdn.shopify.com/s/files/1/0665/4636/8751/t/4/assets/Calendar.svg?v=125328959286357559381686159672" alt="" class="icon">
    //   <div style="font-family: Inconsolata, monospace!important">Agregar Evento</div>
    // </a>`)
    fields.push(`<div id="wsEventsSection" class="flex ver mini-gap"></div>`)
    clase = 'mini-'
  }
  if (sectionName == 'Imagen grande con texto' || sectionName == 'Banner Pequeño' || sectionName == 'Banner Grande' || sectionName == 'Texto con imagen a la izquierda' || sectionName == 'Texto con imagen a la derecha' || sectionName == 'Imagen sobre texto' || sectionName == 'Video Grande' || sectionName == 'Video Chico' || sectionName == 'Texto' || sectionName == 'Galería en cuadrícula' || sectionName == 'Galería en carrusel' || sectionName == 'Galería en lista') {
    fields.push(`<div class="cust-field-wrap">
                <label class="field-label">Descripción</label><textarea
                  id="description-input-${sectionCount}"
                  name="field-3"
                  maxlength="5000"
                  data-name="Field 3"
                  placeholder="Descripción"
                  class="cust-input textarea w-input"
                ></textarea>
              </div>`)
  }
  if (sectionName == 'Imagen grande con texto' || sectionName == 'Banner Pequeño' || sectionName == 'Banner Grande' || sectionName == 'Texto con imagen a la izquierda' || sectionName == 'Texto con imagen a la derecha' || sectionName == 'Imagen sobre texto') {
    fields.push(`<div class="cust-field-wrap">
                <label for="field" class="field-label">Imagen (Comprueba que la imagen no supere los 20MP ni los 20 MB, de lo contrario no se guardará)</label
                ><input
                  type="file"
                  accept="image/png, image/jpeg"
                  maxlength="256"
                  name="title"
                  data-name="Field"
                  placeholder="Imagen"
                  id="image-input-${sectionCount}"
                  required=""
                >
              </div>`)
  }
  if (sectionName == 'Imagen grande con texto' || sectionName == 'Banner Pequeño' || sectionName == 'Banner Grande' || sectionName == 'Texto con imagen a la izquierda' || sectionName == 'Texto con imagen a la derecha' || sectionName == 'Imagen sobre texto' || sectionName == 'Texto') {
    fields.push(`<div class="cust-field-wrap">
                <label for="field" class="field-label">Link de botón (debe empezar con https://)</label
                ><input
                  type="text"
                  class="cust-input w-input"
                  maxlength="256"
                  name="title"
                  data-name="Field"
                  placeholder="Link de botón"
                  id="link-input-${sectionCount}"
                  required=""
                >
              </div>`)
  }
  if (sectionName == 'Imagen grande con texto' || sectionName == 'Banner Pequeño' || sectionName == 'Banner Grande' || sectionName == 'Texto con imagen a la izquierda' || sectionName == 'Texto con imagen a la derecha' || sectionName == 'Imagen sobre texto' || sectionName == 'Texto') {
    fields.push(`<div class="cust-field-wrap">
                <label for="field" class="field-label">Texto de botón</label
                ><input
                  type="text"
                  class="cust-input w-input"
                  maxlength="256"
                  name="title"
                  data-name="Field"
                  placeholder="Texto de botón"
                  id="linkText-input-${sectionCount}"
                  required=""
                >
              </div>`)
  }
  if (sectionName == 'Video Grande' || sectionName == 'Video Chico') {
    fields.push(`<div class="cust-field-wrap">
                <label for="field" class="field-label">Video (Debe ser de YouTube)</label
                ><input
                  type="text"
                  maxlength="256"
                  class="cust-input w-input"
                  name="title"
                  data-name="Field"
                  placeholder="Link de YouTube"
                  id="video-input-${sectionCount}"
                  required=""
                >
              </div>`)
  }
  if (sectionName == 'Galería en cuadrícula' || sectionName == 'Galería en carrusel' || sectionName == 'Galería en lista') {
    fields.push(`<div class="flex ver mini-gap">
    <div id="block_container_${sectionCount}"></div>
                  <a href="#" id="addBlockBtn${sectionCount}" index="${index}" onclick="addBlock(this)" name="${sectionName}" nmb="${sectionCount}" class="cust-add w-inline-block"
                    ><img
                      loading="lazy"
                      src="//cdn.shopify.com/s/files/1/0665/4636/8751/t/3/assets/grid-02.svg?v=80591925488279998351678131648"
                      alt=""
                      class="icon"
                    >
                    <div>Agregar Bloque</div>
                  </a>
                  </div>`)
  }
  if (sectionName == 'Mapa') {
    fields.push(`<div id="block_container_${sectionCount}">
                  </div>
                  <a href="#" id="addBlockBtn${sectionCount}" index="${index}" onclick="addMapBlock(this)" name="${sectionName}" nmb="${sectionCount}" class="cust-add w-inline-block"
                    ><img
                      loading="lazy"
                      src="//cdn.shopify.com/s/files/1/0665/4636/8751/t/3/assets/grid-02.svg?v=80591925488279998351678131648"
                      alt=""
                      class="icon"
                    >
                    <div>Agregar Ubicación</div>
                  </a>`)
  }
  $('#sections_dd_container_' + index).append(`<div id="dd-container_${sectionCount}" nmb="${sectionCount}" data-delay="0" data-hover="false" class="cust-dd w-dropdown">
                                <div onclick="showSectionFields(${sectionCount})" class="cust-dd-tog w-dropdown-toggle">
                                  <div style="font-family: Inconsolata, monospace!important">${sectionName}</div>
                                  <div class="dd-icon w-icon-dropdown-toggle"></div>
                                </div>
                                <nav id="section_${sectionCount}" class="cust-dd-drawer w-dropdown-list">
                                  <div class="flex ver ${clase}gap">
                                  ${fields.join().replaceAll(',', '')}
                                  
                                  <a href="#" onclick="deleteDD(${sectionCount},${index})" class="cust-del w-inline-block"
                                    ><img loading="lazy" src="//cdn.shopify.com/s/files/1/0665/4636/8751/t/3/assets/trash-01.svg?v=79518031219586732181678131632" alt="" class="icon">
                                    <div style="color:#e73535">Eliminar Sección</div>
                                  </a>
                                  </div>
                                </nav>
                              </div>`)

  createSection(sectionName, sectionCount, index)
  if (show) {
    showSectionFields(sectionCount)
  }
  sectionCount++
  var existEvents = false
  for (let i = 0; i < sectionsContent.length; i++) {
    for (let j = 0; j < sectionsContent[i].length; j++) {
      if (sectionsContent[i][j].type == "wedsite_secciones_eventos") {
        existEvents = true
      }
    }
  }
  if (existEvents) {
    for (let i = 0; i < sectionsContent.length; i++) {
      $('.mainEventsDD' + i).attr('onclick', '')
      $('.mainEventsDD' + i).css('background-color', '#c0c0c0')
      $('.mainEventsDD' + i).css('cursor', 'default')
    }
  }
  else {
    for (let i = 0; i < sectionsContent.length; i++) {
      $('.mainEventsDD' + i).attr('onclick', "addSection('Eventos'," + i + ",true)")
      $('.mainEventsDD' + i).css('background-color', 'transparent')
      $('.mainEventsDD' + i).css('cursor', 'pointer')
    }
  }
}

async function createSection(sectionName, nmb, index) {
  var section
  if (sectionName == 'Imagen grande con texto') {
    section = createFoldSection(nmb)
    sectionsContent[index].push({ "id": nmb, "type": "secciones_hero", "fields": [{ "key": "layout", "value": "Hero" }, { "key": "titulo_de_seccion", "value": "" }, { "key": "contenido_de_seccion", "value": "" }, { "key": "imagen", "value": "" }, { "key": "link_de_seccion", "value": "" }, { "key": "texto_de_link", "value": "" }, { "key": "id_de_relacion", "value": "" }] })
  }
  if (sectionName == 'Banner Pequeño') {
    section = createSmallBannerSection(nmb)
    sectionsContent[index].push({ "id": nmb, "type": "secciones_banner", "fields": [{ "key": "layout", "value": "Pequeño" }, { "key": "titulo_de_seccion", "value": "" }, { "key": "contenido_de_seccion", "value": "" }, { "key": "imagen_de_seccion", "value": "" }, { "key": "link_de_seccion", "value": "" }, { "key": "texto_de_link", "value": "" }, { "key": "id_de_relacion", "value": "" }] })
  }
  if (sectionName == 'Banner Grande') {
    section = createBigBannerSection(nmb)
    sectionsContent[index].push({ "id": nmb, "type": "secciones_banner", "fields": [{ "key": "layout", "value": "Pantalla Completa" }, { "key": "titulo_de_seccion", "value": "" }, { "key": "contenido_de_seccion", "value": "" }, { "key": "imagen_de_seccion", "value": "" }, { "key": "link_de_seccion", "value": "" }, { "key": "texto_de_link", "value": "" }, { "key": "id_de_relacion", "value": "" }] })
  }
  if (sectionName == 'Texto con imagen a la izquierda') {
    section = createImageLeftBannerSection(nmb)
    sectionsContent[index].push({ "id": nmb, "type": "secciones_banner", "fields": [{ "key": "layout", "value": "Imagen Izquierda" }, { "key": "titulo_de_seccion", "value": "" }, { "key": "contenido_de_seccion", "value": "" }, { "key": "imagen_de_seccion", "value": "" }, { "key": "link_de_seccion", "value": "" }, { "key": "texto_de_link", "value": "" }, { "key": "id_de_relacion", "value": "" }] })
  }
  if (sectionName == 'Texto con imagen a la derecha') {
    section = createImageRightBannerSection(nmb)
    sectionsContent[index].push({ "id": nmb, "type": "secciones_banner", "fields": [{ "key": "layout", "value": "Imagen Derecha" }, { "key": "titulo_de_seccion", "value": "" }, { "key": "contenido_de_seccion", "value": "" }, { "key": "imagen_de_seccion", "value": "" }, { "key": "link_de_seccion", "value": "" }, { "key": "texto_de_link", "value": "" }, { "key": "id_de_relacion", "value": "" }] })
  }
  if (sectionName == 'Imagen sobre texto') {
    section = createOverBannerSection(nmb)
    sectionsContent[index].push({ "id": nmb, "type": "secciones_banner", "fields": [{ "key": "layout", "value": "Imagen Sobre Texto" }, { "key": "titulo_de_seccion", "value": "" }, { "key": "contenido_de_seccion", "value": "" }, { "key": "imagen_de_seccion", "value": "" }, { "key": "link_de_seccion", "value": "" }, { "key": "texto_de_link", "value": "" }, { "key": "id_de_relacion", "value": "" }] })
  }
  if (sectionName == 'Video Grande') {
    section = createBigVideoSection(nmb)
    sectionsContent[index].push({ "id": nmb, "type": "secciones_video", "fields": [{ "key": "layout", "value": "Video Grande" }, { "key": "titulo_de_seccion", "value": "" }, { "key": "descripcion_de_seccion", "value": "" }, { "key": "link_del_video", "value": "" }, { "key": "id_de_relacion", "value": "" }] })
  }
  if (sectionName == 'Video Chico') {
    section = createSmallVideoSection(nmb)
    sectionsContent[index].push({ "id": nmb, "type": "secciones_video", "fields": [{ "key": "layout", "value": "Video Pequeño" }, { "key": "titulo_de_seccion", "value": "" }, { "key": "descripcion_de_seccion", "value": "" }, { "key": "link_del_video", "value": "" }, { "key": "id_de_relacion", "value": "" }] })
  }
  if (sectionName == 'Texto') {
    section = createTextSection(nmb)
    sectionsContent[index].push({ "id": nmb, "type": "secciones_texto", "fields": [{ "key": "layout", "value": "Texto" }, { "key": "titulo_de_seccion", "value": "" }, { "key": "texto_de_seccion", "value": "" }, { "key": "link_de_seccion", "value": "" }, { "key": "texto_de_link", "value": "" }, { "key": "id_de_relacion", "value": "" }] })
  }
  if (sectionName == 'Galería en cuadrícula') {
    section = createGridGallerySection(nmb)
    sectionsContent[index].push({ "id": nmb, "type": "secciones_galeria", "images": [], "fields": [{ "key": "layout", "value": "Cuadrícula" }, { "key": "titulo_de_seccion", "value": "" }, { "key": "contenido_de_seccion", "value": "" }, { "key": "bloques", "value": "" }, { "key": "id_de_relacion", "value": "" }] })
  }
  if (sectionName == 'Galería en carrusel') {
    section = createSliderGallerySection(nmb)
    sectionsContent[index].push({ "id": nmb, "type": "secciones_galeria", "images": [], "fields": [{ "key": "layout", "value": "Carrusel" }, { "key": "titulo_de_seccion", "value": "" }, { "key": "contenido_de_seccion", "value": "" }, { "key": "bloques", "value": "" }, { "key": "id_de_relacion", "value": "" }] })
  }
  if (sectionName == 'Galería en lista') {
    section = createListGallerySection(nmb)
    sectionsContent[index].push({ "id": nmb, "type": "secciones_galeria", "images": [], "fields": [{ "key": "layout", "value": "Lista" }, { "key": "titulo_de_seccion", "value": "" }, { "key": "contenido_de_seccion", "value": "" }, { "key": "bloques", "value": "" }, { "key": "id_de_relacion", "value": "" }] })
  }
  if (sectionName == 'Mapa') {
    section = createMapSection(nmb)
    sectionsContent[index].push({ "id": nmb, "type": "secciones_mapa", "ubications": [], "fields": [{ "key": "layout", "value": "Mapa" }, { "key": "titulo_de_seccion", "value": "" }, { "key": "ubicaciones", "value": "" }, { "key": "id_de_relacion", "value": "" }] })
  }
  if (sectionName == 'Eventos') {
    section = createEventSection(nmb)
    sectionsContent[index].push({ "id": nmb, "type": "wedsite_secciones_eventos", "fields": [{ "key": "layout", "value": "Eventos" }, { "key": "eventos", "value": $('#collection_events').attr('eventsid') }, { "key": "id_de_relacion", "value": "" }] })
  }
  $('#home-content-' + index).append(section)
  if (sectionName == 'Eventos') {
    for (let i = 0; i < initialEventsData.length; i++) {
      //$('#section-'+nmb).append(createEventItem(initialEventsData[i].id,initialEventsData[i].fields[3].value,initialEventsData[i].fields[1].value,initialEventsData[i].fields[0].value,initialEventsData[i].fields[2].value,initialEventsData[i].ubicacion_fields[1].value,initialEventsData[i].ubicacion_fields[0].value))
      wsaddEventoBlock(nmb, initialEventsData[i].fields[0].value, initialEventsData[i].fields[2].value, initialEventsData[i].fields[1].value, initialEventsData[i].fields[3].value, initialEventsData[i].ubicacion_fields[0].value, initialEventsData[i].ubicacion_fields[1].value, initialEventsData[i].graphId, initialEventsData[i].fields[4].value, initialEventsData[i].fields[5].value)
    }
  }
  /*
  if(sectionName == 'Mapa'){
    var ubications = JSON.parse($('#collection_events').attr('ubications'))
    for(let i = 0 ; i < ubications.length ; i++){
      $('#ubication-element-container-'+nmb).append(createUbicationItem(ubications[i].link_a_google_maps,ubications[i].nombre_de_ubicacion))
    }
  }
  */
  if ($('#title-input-' + nmb).length) {
    document.getElementById('title-input-' + nmb).addEventListener('input', (e) => {
      $('#title-' + nmb).text(e.target.value)
      for (let i = 0; i < sectionsContent[index].length; i++) {
        if (sectionsContent[index][i].id == nmb) {
          for (let j = 0; j < sectionsContent[index][i].fields.length; j++) {
            if (sectionsContent[index][i].fields[j].key == "titulo_de_seccion") {
              sectionsContent[index][i].fields[j].value = e.target.value
              break
            }
          }
        }
      }
    })
  }
  if ($('#description-input-' + nmb).length) {
    document.getElementById('description-input-' + nmb).addEventListener('input', (e) => {
      $('#content-' + nmb).text(e.target.value)
      for (let i = 0; i < sectionsContent[index].length; i++) {
        if (sectionsContent[index][i].id == nmb) {
          for (let j = 0; j < sectionsContent[index][i].fields.length; j++) {
            if (sectionsContent[index][i].fields[j].key == "contenido_de_seccion") {
              sectionsContent[index][i].fields[j].value = e.target.value
              break
            }
            if (sectionsContent[index][i].fields[j].key == "descripcion_de_seccion") {
              sectionsContent[index][i].fields[j].value = e.target.value
              break
            }
            if (sectionsContent[index][i].fields[j].key == "texto_de_seccion") {
              sectionsContent[index][i].fields[j].value = e.target.value
              break
            }
          }
        }
      }
    })
  }
  if ($('#linkText-input-' + nmb).length) {
    document.getElementById('linkText-input-' + nmb).addEventListener('input', (e) => {
      $('#link-' + nmb).removeClass('d-none')
      $('#link-' + nmb).text(e.target.value)
      for (let i = 0; i < sectionsContent[index].length; i++) {
        if (sectionsContent[index][i].id == nmb) {
          for (let j = 0; j < sectionsContent[index][i].fields.length; j++) {
            if (sectionsContent[index][i].fields[j].key == "texto_de_link") {
              sectionsContent[index][i].fields[j].value = e.target.value
              break
            }
          }
        }
      }
    })
  }
  if ($('#link-input-' + nmb).length) {
    document.getElementById('link-input-' + nmb).addEventListener('input', (e) => {
      var val = e.target.value
      if (!e.target.value.includes('http')) {
        val = 'https://' + e.target.value
      }
      val = val.replaceAll(' ', '')
      if (val == 'https://') {
        val = ''
      }
      $('#link-' + nmb).attr("href", val)
      for (let i = 0; i < sectionsContent[index].length; i++) {
        if (sectionsContent[index][i].id == nmb) {
          for (let j = 0; j < sectionsContent[index][i].fields.length; j++) {
            if (sectionsContent[index][i].fields[j].key == "link_de_seccion") {
              sectionsContent[index][i].fields[j].value = val
              break
            }
          }
        }
      }
    })
  }
  if ($('#image-input-' + nmb).length) {
    document.getElementById('image-input-' + nmb).addEventListener('change', async (event) => {
      var file = document.getElementById('image-input-' + nmb);
      var resolution
      var file, img;
      if ((file = event.target.files[0])) {
        img = new Image();
        var objectUrl = _URL.createObjectURL(file);
        console.log(file)
        console.log(objectUrl)
        img.onload = async function () {
          _URL.revokeObjectURL(objectUrl);
          resolution = (this.width * this.height) / 1000000
          console.log(resolution)

          if (resolution < 20) {
            if ($('#image-warning-' + nmb).length > 0) {
              $('#image-warning-' + nmb).remove()
            }
            var previewImage = document.getElementById('image-' + nmb)
            var file = event.target.files[0];
            var fileId = await getFileId(file)
            for (let i = 0; i < sectionsContent[index].length; i++) {
              if (sectionsContent[index][i].id == nmb) {
                for (let j = 0; j < sectionsContent[index][i].fields.length; j++) {
                  if (sectionsContent[index][i].fields[j].key == "imagen_de_seccion") {
                    sectionsContent[index][i].fields[j].value = fileId
                    break
                  }
                  if (sectionsContent[index][i].fields[j].key == "imagen") {
                    sectionsContent[index][i].fields[j].value = fileId
                    break
                  }
                }
              }
            }
            var reader = new FileReader();

            reader.onload = (readerEvent) => {
              var image = new Image();
              image.src = readerEvent.target.result;
              previewImage.src = image.src;
            };

            reader.readAsDataURL(file);
          }
          else {
            if ($('#image-warning-' + nmb).length > 0) {
              $('#image-warning-' + nmb).remove()
            }
            console.log(resolution)
            $('#image-input-' + nmb).val('')
            $('#image-input-' + nmb).parent().append('<div id="image-warning-' + nmb + '" style="margin-top:5px;background-color:#fae3d7">La imagen seleccionada debe tener menos de 20MP</div>')
          }
        };
        img.src = objectUrl;
      }
    });
  }
  if ($('#video-input-' + nmb).length) {
    document.getElementById('video-input-' + nmb).addEventListener('input', (e) => {
      var video = e.target.value.replace('watch?v=', 'embed/')
      $('#video-' + nmb).attr("src", video)
      for (let i = 0; i < sectionsContent[index].length; i++) {
        if (sectionsContent[index][i].id == nmb) {
          for (let j = 0; j < sectionsContent[index][i].fields.length; j++) {
            if (sectionsContent[index][i].fields[j].key == "link_del_video") {
              sectionsContent[index][i].fields[j].value = video
              break
            }
          }
        }
      }
    })
  }
}

function b64toBlob(b64Data, contentType = '', sliceSize = 512) {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
}


async function getFileId(file) {
  var fileFields = await createFileUrl(file.name)
  console.log(fileFields)
  var url = fileFields.data.stagedUploadsCreate.stagedTargets[0].url
  var parameters = fileFields.data.stagedUploadsCreate.stagedTargets[0].parameters

  const formData = new FormData()

  parameters.forEach(({ name, value }) => {
    formData.append(name, value)
  })

  formData.append('file', file)

  const response = await fetch(url, {
    method: 'POST',
    body: formData
  })
  if (response.ok) {
    const key = parameters.find(p => p.name === 'key')
    var createdAt = await createFile(url + key.value)
    console.log(createdAt)
    createdAt = createdAt.data.fileCreate.files[0].createdAt
    var fileId = await getLastFile(createdAt)
    fileId = fileId.data.files.edges[0].node.id
    console.log('el fileId es ' + fileId)
  }
  return fileId
}

async function saveWedsite() {
  // PROTECCIÓN 1 (contra pérdida de datos): si el editor no terminó de cargar
  // (p.ej. un caracter especial rompió el script que llena sectionsContent),
  // NO guardamos: hacerlo sobreescribiría el sitio con contenido vacío/parcial.
  if (typeof window.wedsiteEditorLoaded === 'undefined' || window.wedsiteEditorLoaded !== true) {
    generalLoader.on()
    $('.loader-msg').text('El editor no se cargó completamente. No se guardó ningún cambio para no perder tu contenido. Por favor recarga la página e intenta de nuevo.')
    setTimeout(() => { generalLoader.off() }, 7000)
    return
  }
  generalLoader.on()
  $('.loader-msg').text('Guardando cambios')
  for (let n = 0; n < sectionsContent.length; n++) {
    var sectionsIds = []
    var page_metafield = JSON.parse($('#pages_metafield').attr('data'))
    page_metafield = page_metafield[n]
    for (let i = 0; i < sectionsContent[n].length; i++) {
      var galleryImagesIds = []
      var ubicationsIds = []
      if (sectionsContent[n][i].type == "secciones_galeria") {
        for (let j = 0; j < sectionsContent[n][i].images.length; j++) {
          galleryImagesIds.push(await createGeneralMetaobject(sectionsContent[n][i].images[j]))
        }
        galleryImagesIds = galleryImagesIds.filter(function (valor) {
          return valor !== null;
        });
        sectionsContent[n][i].fields[3].value = JSON.stringify(galleryImagesIds)
      }
      if (sectionsContent[n][i].type == "secciones_mapa") {
        for (let j = 0; j < sectionsContent[n][i].ubications.length; j++) {
          if (sectionsContent[n][i].ubications[j].fields[3].value.includes('https://www.google.com/maps/place/')) {
            ubicationsIds.push(await createGeneralMetaobject(sectionsContent[n][i].ubications[j]))
          }
        }
        ubicationsIds = ubicationsIds.filter(function (valor) {
          return valor !== null;
        });
        sectionsContent[n][i].fields[2].value = JSON.stringify(ubicationsIds)
      }
      var showEventMessage = false
      // if (sectionsContent[n][i].type == "wedsite_secciones_eventos") {
      //   console.log('Entrando a seccion eventos')
      //   var showEventMessage = false

      //   if (JSON.parse(sectionsContent[n][i].fields[1].value).length == 0) {
      //     sectionsContent[n][i].fields[1].value = ""
      //   }
      //   else {
      //     sectionsContent[n][i].fields[1].value = []
      //     for (let k = 0; k < subSectionEvents.length; k++) {
      //       var emptyFields = false
      //       for (let l = 0; l < subSectionEvents[k].fields.length; l++) {
      //         console.log(subSectionEvents[k].fields[l].value)
      //         if (subSectionEvents[k].fields[l].value == '' || subSectionEvents[k].fields[l].value == null) {
      //           if (subSectionEvents[k].fields[l].key != 'ubicacion') {
      //             if (subSectionEvents[k].fields[l].key != "requiere_invitacion") {
      //               console.log('tiene vacíos')
      //               emptyFields = true
      //               showEventMessage = true
      //             }
      //           }
      //         }
      //       }
      //       if (!emptyFields) {
      //         if (subSectionEvents[k].graphId != "") {
      //           console.log('Entra al update')
      //           await updateMetaObject(subSectionEvents[k].fields[5].value, subSectionEvents[k].ubicacion_fields)
      //           await updateMetaObject(subSectionEvents[k].graphId, subSectionEvents[k].fields)
      //           sectionsContent[n][i].fields[1].value.push(subSectionEvents[k].graphId)
      //         }
      //         else {
      //           var invUbication = await createGeneralMetaobject({ "type": "bloques_ubicaciones", "fields": subSectionEvents[k].ubicacion_fields })
      //           subSectionEvents[k].fields[5].value = invUbication
      //           sectionsContent[n][i].fields[1].value.push(await createGeneralMetaobject({ "type": "mesa_de_regalos_eventos", "fields": subSectionEvents[k].fields }))
      //         }
      //       }
      //     }
      //     let filteredEventsIds = sectionsContent[n][i].fields[1].value.filter(function (value) {
      //       return value !== null && value !== undefined;
      //     });
      //     sectionsContent[n][i].fields[1].value = JSON.stringify(filteredEventsIds)
      //     await addCollectionMetafield(collectionId, { "namespace": "custom", "key": "eventos", "value": sectionsContent[n][i].fields[1].value, "type": "list.metaobject_reference" })
      //   }
      // }
      for (let f = 0; f < sectionsContent[n][i].fields.length; f++) {
        if (sectionsContent[n][i].fields[f].key == 'id_de_relacion') {
          sectionsContent[n][i].fields[f].value = collectionId + '-' + page_metafield.replace('gid://shopify/Metaobject/', '')
        }
      }
      if (sectionsContent[n][i].type == "wedsite_secciones_eventos") {
        sectionsIds.push(await createGeneralMetaobject(sectionsContent[n][i]))
      }
      else {
        sectionsIds.push(await createGeneralMetaobject(sectionsContent[n][i]))
      }
    }
    let filteredSectionsIds = sectionsIds.filter(function (value) {
      return value !== null && value !== undefined;
    });
    console.log('------------------------------------------------------------------------')
    console.log(sectionsIds)
    console.log(filteredSectionsIds)
    // PROTECCIÓN 2 (contra pérdida de datos): solo seguimos si TODAS las secciones
    // se crearon correctamente. Si createGeneralMetaobject falló en alguna,
    // filteredSectionsIds queda más corto que sectionsContent[n]; en ese caso NO
    // sobreescribimos home_secciones (dejaría la página vacía/incompleta) y NO
    // borramos las secciones viejas. Abortamos y avisamos al usuario.
    if (filteredSectionsIds.length !== sectionsContent[n].length) {
      // No todas las secciones se crearon: NO sobreescribimos home_secciones ni
      // borramos las viejas, para no perder contenido. Avisamos al usuario.
      $('.loader-msg').text('Hubo un problema al guardar y no se aplicaron cambios para no perder tu contenido. Revisa tu conexión e intenta de nuevo. Si el problema persiste, contacta a soporte.')
      setTimeout(() => { generalLoader.off() }, 7000)
      return
    }
    var newSections = await updateMetaObject(page_metafield, [{ "key": "home_secciones", "value": JSON.stringify(filteredSectionsIds) }])
    console.log(newSections)
    // Solo borramos las secciones viejas DESPUÉS de confirmar que la escritura
    // del nuevo home_secciones fue exitosa (sin 'status' de error en la respuesta).
    if (!('status' in newSections)) {
      var sections_metafields = JSON.parse($('#sections_metafield').attr('data'))
      for (let i = 0; i < sections_metafields.length; i++) {
        for (let j = 0; j < sections_metafields[i].length; j++) {
          await deletelMetaobject(sections_metafields[i][j])
        }
      }
    }
  }
  var design_metafield = $('#design_metafield').attr('data')
  if ($('#font-selector').val() == null) {
    var tip1 = ''
  }
  else {
    var tip1 = $('#font-selector').val()
  }
  if ($('#font-selector-2').val() == null) {
    var tip2 = ''
  }
  else {
    var tip2 = $('#font-selector-2').val()
  }
  await updateMetaObject(design_metafield, [{ "key": "color_primario", "value": $('#color-primario').val() }, { "key": "color_secundario", "value": $('#color-secundario').val() }, { "key": "color_terciario", "value": $('#color-terciario').val() }, { "key": "tipografia_principal", "value": tip1 }, { "key": "tipografia_de_apoyo", "value": tip2 }])
  //addPageMetafield($('#pageId').attr('data'),{"key": "imagen_de_pagina","value": fileId,"type": "file_reference","namespace": "custom"})
  addPageMetafield($('#pageId').attr('data'), { "key": "tel_fono_de_contacto", "value": $('#cTel').val(), "type": "single_line_text_field", "namespace": "custom" })
  addPageMetafield($('#pageId').attr('data'), { "key": "email_de_contacto", "value": $('#cEmail').val(), "type": "single_line_text_field", "namespace": "custom" })
  if (showEventMessage) {
    $('.loader-msg').text('Algunos eventos no se guardaron debido a que no se rellenaron todos los campos')
  }
  $('.loader-msg').text('Los cambios se guardaron correctamente, espera un momento mientras se recarga la página')
  setTimeout(() => {
    generalLoader.off()
    location.reload()
  }, 5000)
}

function addPage() {
  $('#addPageForm').slideDown()
  $('#addPageDone').slideUp()
  $('#addPageFail').slideUp()
  $('.modal-fix.addPage').css({
    "display": "flex",
    "opacity": "1"
  })
  $('.modal.addPage').css('opacity', '1')
}

async function createNewPage() {
  generalLoader.on()
  $('.loader-msg').text('Creando nueva página')
  if ($('#addPageName').val() != '') {
    var pagina = await createTableHomePage($('#addPageName').val())
    var metafields = await getPageMetafield($('#pageId').attr('data'))
    var paginas
    for (const met of metafields) {
      if (met.key == "wedsite_p_ginas") {
        paginas = JSON.parse(met.value)
      }
    }
    paginas.push(pagina)
    console.log(paginas)
    console.log(JSON.stringify(paginas))
    await addPageMetafield($('#pageId').attr('data'), { "key": "wedsite_p_ginas", "value": JSON.stringify(paginas), "type": "list.metaobject_reference", "namespace": "custom" })
    $('#addPageForm').slideUp()
    setTimeout(() => {
      $('#addPageDone').slideDown()
    }, 300)
    await setTimeout(() => {
      location.reload()
    }, 4000)
  }
  else {
    $('#addPageFail').slideDown()
  }
  generalLoader.off()
}

var deletePageObject
function showDeletePageModal(e) {
  $('#deletePageForm').slideDown()
  $('#deletePageDone').slideUp()
  $('.modal-fix.deletePage').css({
    "display": "flex",
    "opacity": "1"
  })
  deletePageObject = e.getAttribute('objectid')
  $('.modal.deletePage').css('opacity', '1')
}

async function deletePage() {
  generalLoader.on()
  $('.loader-msg').text('Borrando página')
  console.log(deletePageObject)
  await deletelMetaobject(deletePageObject.replaceAll('"', ''))
  $('#deletePageForm').slideUp()
  $('#deletePageDone').slideDown()
  await setTimeout(() => {
    location.reload()
  }, 4000)
  generalLoader.off()
}




function formatearFecha(fecha) {
  const meses = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre'
  ];

  const partes = fecha.split('-');
  const anio = partes[0];
  const mes = parseInt(partes[1], 10);
  const dia = parseInt(partes[2], 10);

  const fechaFormateada = `${dia} de ${meses[mes - 1]} de ${anio}`;

  return fechaFormateada;
}





function wsaddEventoBlock(nmb, nombre = "Nuevo Evento", descripcion = "", fecha = "", vestimenta = "", ubicacion = "", link = "", graphId = "", requiere = "", ubiId = "") {
  var fecha1 = fecha
  var fecha2 = fecha
  if (fecha == "") {
    fecha = "T:00+00:00"
  }
  else {
    fecha = formatearFecha(fecha.split('T')[0]) + 'T' + fecha.split('T')[1]
    fecha = fecha.replaceAll(' ', '-')
  }
  if (fecha1.length == 25) {
    var date = fecha1
    var hour = (parseInt(date.substring(11, 13)) - 6)
    var formatedDate = date.substring(0, 10)
    if (hour < 0) {
      hour = 24 + hour
      formatedDate = restarUnDia(date.substring(0, 10))
    }
    if (hour > 24) {
      hour = hour - 24
      formatedDate = sumarUnDia(date.substring(0, 10))
    }
    if (hour < 10) {
      hour = '0' + hour
    }
    formatedDate = formatedDate + 'T'
    date = formatedDate + hour + date.substring(13)
    if (date.length < 19) {
      date = date + ':00'
    }
    fecha1 = date
  }
  $('#section-' + nmb).append(createEventItem(wsEventCount, vestimenta, fecha, nombre, descripcion, link, ubicacion))
  var requiereCampos = `<label class="w-checkbox check"><input type="checkbox" id="ws-require-${wsEventCount}" name="checkbox" data-name="Checkbox" class="w-checkbox-input check-btn"><span class="check-label w-form-label" for="checkbox">¿Quieres que Zépika se encargue de las confirmaciones para este evento?</span></label>`
  if (requiere == "true") {
    requiereCampos = `<label class="w-checkbox check w--redirected-checked"><input type="checkbox" id="ws-require-${wsEventCount}" checked name="checkbox" data-name="Checkbox" class="w-checkbox-input check-btn"><span class="check-label w-form-label" for="checkbox">¿Quieres que Zépika se encargue de las confirmaciones para este evento?</span></label>`
  }
  $('#wsEventsSection').append(`<div id="ws-dd-cevent_${wsEventCount}" parent="${wsEventCount}" data-delay="0" data-hover="false" class="cust-dd w-dropdown">
            <div onclick="showInvSectionFields('ws-event-${wsEventCount}')" class="cust-dd-tog sub-dd w-dropdown-toggle">
              <div id="ws-dd-Event-Title-${wsEventCount}">${nombre}</div>
              <div class="dd-icon w-icon-dropdown-toggle"></div>
            </div>
            <nav id="ws-event-${wsEventCount}" class="cust-dd-drawer w-dropdown-list">
            <div class="flex ver gap">
              <div class="cust-field-wrap">
                <label for="field" class="field-label">Nombre del Evento:</label>
                <label for="field" class="field-label">${nombre}</label>
              </div>
              <div class="cust-field-wrap">
                <label class="field-label">Descripción:</label>
                <label class="field-label">${descripcion}</label>
              </div>
              <div class="cust-field-wrap">
                <label class="field-label">Fecha:</label>
                <label class="field-label">${fecha1.replace('+00:00', '')}</label>
              </div>
              <div class="cust-field-wrap">
                <label for="field" class="field-label">Código de vestimenta:</label>
                <label for="field" class="field-label">${vestimenta}</label>
              </div>
              <div class="cust-field-wrap">
                <label for="field" class="field-label">Nombre de la ubicación:</label>
                <label for="field" class="field-label">${ubicacion}</label>
              </div>
              <div class="cust-field-wrap">
                <label for="field" class="field-label">Link de Google Maps:</label>
                <label for="field" class="field-label">${link}</label>
              </div>
              <a href="/account?Dashboard=1&section=Configuracion" target="blank" class="btn auto-btn w-button save-btn" style="color: #fff;">
                Editar evento
              </a>
              </div>
            </nav>
          </div>`)
  subSectionEvents.push({
    "id": wsEventCount,
    "graphId": graphId,
    "fields": [
      { "key": "nombre_del_evento", "value": nombre },
      { "key": "fecha_y_hora", "value": fecha2 },
      { "key": "descripcion", "value": descripcion },
      { "key": "codigo_de_vestimenta", "value": vestimenta },
      { "key": "requiere_invitacion", "value": requiere },
      { "key": "ubicacion", "value": ubiId }
    ],
    "ubicacion_fields": [
      { "key": "nombre_de_ubicacion", "value": ubicacion },
      { "key": "link_a_google_maps", "value": link }
    ]
  })
  flatpickr("#ws-date-" + wsEventCount, { enableTime: true, minDate: "today" });
  wsInitEvent(wsEventCount)
  wsEventCount++
}

function wsdeleteEventDD(nmb) {
  for (let i = 0; i < subSectionEvents.length; i++) {
    if (subSectionEvents[i].id == nmb) {
      subSectionEvents.splice(i, 1)
    }
  }
  $('#ws-dd-cevent_' + nmb).remove()
  $('.ws-Event-' + nmb + '-0').remove()
}

function wsInitEvent(nmb) {
  const wsTitleEl = document.getElementById('ws-title-' + nmb)
  if (!wsTitleEl) {
    return
  }

  wsTitleEl.addEventListener('change', async (e) => {
    $('#ws-title-val-' + nmb).text(e.target.value)
    $('#ws-dd-Event-Title-' + nmb).text(e.target.value)
    for (let i = 0; i < subSectionEvents.length; i++) {
      if (subSectionEvents[i].id == nmb) {
        for (let j = 0; j < subSectionEvents[i].fields.length; j++) {
          if (subSectionEvents[i].fields[j].key == "nombre_del_evento") {
            subSectionEvents[i].fields[j].value = e.target.value
            break
          }
        }
      }
    }
  })
  document.getElementById('ws-date-' + nmb).addEventListener('change', async (e) => {
    $('#ws-date1-val-' + nmb).text(formatearFecha(e.target.value.split(' ')[0]))
    $('#ws-date2-val-' + nmb).text(e.target.value.split(' ')[1])
    for (let i = 0; i < subSectionEvents.length; i++) {
      if (subSectionEvents[i].id == nmb) {
        for (let j = 0; j < subSectionEvents[i].fields.length; j++) {
          if (subSectionEvents[i].fields[j].key == "fecha_y_hora") {
            var date = e.target.value.replace('T', ' ')
            date = date.replace(' ', 'T')
            var hour = (parseInt(date.substring(11, 13)) + 6)
            var formatedDate = date.substring(0, 10)
            if (hour < 0) {
              hour = 24 + hour
              formatedDate = restarUnDia(date.substring(0, 10))
            }
            if (hour > 24) {
              hour = hour - 24
              formatedDate = sumarUnDia(date.substring(0, 10))
            }
            if (hour < 10) {
              hour = '0' + hour
            }
            formatedDate = formatedDate + 'T'
            date = formatedDate + hour + date.substring(13)
            if (date.length < 19) {
              date = date + ':00'
            }
            subSectionEvents[i].fields[j].value = date
            break
          }
        }
      }
    }
  })
  document.getElementById('ws-description-' + nmb).addEventListener('change', async (e) => {
    $('#ws-description-val-' + nmb).text(e.target.value)
    for (let i = 0; i < subSectionEvents.length; i++) {
      if (subSectionEvents[i].id == nmb) {
        for (let j = 0; j < subSectionEvents[i].fields.length; j++) {
          if (subSectionEvents[i].fields[j].key == "descripcion") {
            subSectionEvents[i].fields[j].value = e.target.value
            break
          }
        }
      }
    }
  })
  document.getElementById('ws-outfit-' + nmb).addEventListener('change', async (e) => {
    $('#ws-outfit-val-' + nmb).text(e.target.value)
    for (let i = 0; i < subSectionEvents.length; i++) {
      if (subSectionEvents[i].id == nmb) {
        for (let j = 0; j < subSectionEvents[i].fields.length; j++) {
          if (subSectionEvents[i].fields[j].key == "codigo_de_vestimenta") {
            subSectionEvents[i].fields[j].value = e.target.value
            break
          }
        }
      }
    }
  })
  document.getElementById('ws-require-' + nmb).addEventListener('change', async (e) => {
    for (let i = 0; i < subSectionEvents.length; i++) {
      if (subSectionEvents[i].id == nmb) {
        for (let j = 0; j < subSectionEvents[i].fields.length; j++) {
          if (subSectionEvents[i].fields[j].key == "requiere_invitacion") {
            if (e.target.checked) {
              subSectionEvents[i].fields[j].value = "true"
            }
            else {
              subSectionEvents[i].fields[j].value = "false"
            }
            break
          }
        }
      }
    }
  })
  document.getElementById('ws-place-' + nmb).addEventListener('change', async (e) => {
    $('#ws-place-valText-' + nmb).text(e.target.value)
    for (let i = 0; i < subSectionEvents.length; i++) {
      if (subSectionEvents[i].id == nmb) {
        for (let j = 0; j < subSectionEvents[i].ubicacion_fields.length; j++) {
          if (subSectionEvents[i].ubicacion_fields[j].key == "nombre_de_ubicacion") {
            subSectionEvents[i].ubicacion_fields[j].value = e.target.value
            break
          }
        }
      }
    }
  })
  document.getElementById('ws-googleLink-' + nmb).addEventListener('change', async (e) => {

    $('#ws-place-val-' + nmb).attr('href', e.target.value)
    for (let i = 0; i < subSectionEvents.length; i++) {
      if (subSectionEvents[i].id == nmb) {
        for (let j = 0; j < subSectionEvents[i].ubicacion_fields.length; j++) {
          if (subSectionEvents[i].ubicacion_fields[j].key == "link_a_google_maps") {
            subSectionEvents[i].ubicacion_fields[j].value = e.target.value.replaceAll(' ', '')
            break
          }
        }
      }
    }
  })
}